import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(): boolean {
    const cropmapToken = this.storageService.Get('cropmap_token');

    if (cropmapToken) {
      return true;
    } else {
      this.authService.logOut();
      return false;
    }
  }
}
